import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail } from 'lucide-react';
import { BrandLogo } from './BrandLogo';
const smoothEase = [0.22, 1, 0.36, 1];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: smoothEase
    }
  }
};
export function ContactSection() {
  return <section className="w-full py-28 md:py-36" data-id="element-39">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-40">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className="flex flex-col items-center" data-id="element-41">
          {/* Decorative line */}
          <motion.div variants={itemVariants} className="w-12 h-px bg-luxury-gold/50 mb-10" data-id="element-42" />

          <motion.h2 variants={itemVariants} className="font-playfair text-3xl md:text-5xl text-luxury-cream mb-16" data-id="element-43">
            Arrange a Private Inspection
          </motion.h2>

          {/* Agent Card */}
          <motion.div variants={itemVariants} className="mb-12 flex flex-col items-center" data-id="element-44">
            <BrandLogo className="h-3 w-auto opacity-25 mb-10" fill="#7a6e60" data-id="element-45" />

            <div className="w-28 h-28 md:w-36 md:h-36 rounded-full overflow-hidden mb-7 ring-1 ring-luxury-divider ring-offset-4" style={{
            '--tw-ring-offset-color': '#D6E8F5'
          } as React.CSSProperties} data-id="element-46">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/gabqpeezghr8tbpjttxqfh/2c2eebf7-9e66-41b7-b907-ac9458f889b0/Luca-Pignalosa-scaled.jpg" alt="Luca Pignalosa" className="w-full h-full object-cover object-top" data-id="element-47" />
            </div>
            <h3 className="font-playfair text-xl md:text-2xl text-luxury-cream mb-1" data-id="element-48">
              Luca Pignalosa
            </h3>
            <span className="text-luxury-taupe/70 text-[11px] tracking-[0.25em] uppercase mb-8" data-id="element-49">
              Sales Executive
            </span>

            <div className="flex flex-col items-center gap-4" data-id="element-50">
              <a href="tel:+61497017146" className="flex items-center gap-3 text-luxury-taupe hover:text-luxury-cream transition-colors duration-500" data-id="element-51">
                <Phone className="w-4 h-4" strokeWidth={1.25} data-id="element-52" />
                <span className="text-sm tracking-[0.1em]" data-id="element-53">
                  +61 497 017 146
                </span>
              </a>
              <a href="mailto:lucap@abercrombys.com.au" className="flex items-center gap-3 text-luxury-taupe hover:text-luxury-cream transition-colors duration-500" data-id="element-54">
                <Mail className="w-4 h-4" strokeWidth={1.25} data-id="element-55" />
                <span className="text-sm tracking-[0.05em]" data-id="element-56">
                  lucap@abercrombys.com.au
                </span>
              </a>
            </div>
          </motion.div>

          {/* Divider */}
          <motion.div variants={itemVariants} className="w-px h-8 bg-luxury-divider mb-8" data-id="element-57" />

          {/* Brand + CTA */}
          <motion.div variants={itemVariants} className="flex flex-col items-center gap-10" data-id="element-58">
            <motion.a href="#enquire" whileHover={{
            scale: 1.03,
            y: -2
          }} whileTap={{
            scale: 0.98
          }} transition={{
            duration: 0.35,
            ease: smoothEase
          }} className="group relative inline-flex items-center justify-center px-14 py-5 bg-luxury-gold text-white overflow-hidden shadow-[0_4px_24px_rgba(184,151,90,0.25)] hover:shadow-[0_8px_36px_rgba(184,151,90,0.4)] transition-shadow duration-500 ease-out" data-id="element-59">
              <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/15 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-1000 ease-out" data-id="element-60" />
              <span className="relative text-[11px] md:text-xs font-medium tracking-[0.3em] uppercase" data-id="element-61">
                Enquire Now
              </span>
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}